import { compose } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { PureComponent } from "react";
import Delete from "@material-ui/icons/Delete";
import { Tooltip, IconButton } from "@material-ui/core";

import {
  getCompanies,
  getSubContractors,
  editSubContractorOnSubmit,
  createSubContractorOnSubmit,
  deleteSubContractor,
} from "features/planner/planner.actions";

import {
  ACTIONS,
  SUB_CONTRACTOR_FORM,
} from "features/planner/planner.constants";

import CrudBasePage from "app/components/CrudBasePage";
import { toSubContractorCard } from "utils/route.util";
import { getSummarizedDataStatesFromState } from "app/app.selectors";
import { getSubContractorsFromState } from "features/planner/planner.selectors";
import SubContractorForm from "features/planner/settings/subcontractors/SubContractorForm";

class SettingsSubContractorsContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad } = this.props;
    dispatchOnLoad();
  }

  columns = [
    {
      xs: true,
      title: "Name",
      getSortProperty: item => item.getIn(["employee", "displayName"]),
    },
    {
      xs: true,
      title: "Company",
      getSortProperty: item => item.getIn(["employee", "companyName"]),
    },
    {
      xs: true,
      title: "Phone",
      getSortProperty: item => item.getIn(["employee", "phone"]),
    },
  ];

  actions = [
    {
      getValue: item => (
        <Tooltip title="Delete">
          <IconButton
            onClick={() => this.props.dispatchDeleteSubContractor(item)}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  render() {
    const {
      Icon,
      breadcrumb,
      dataState,
      subContractors,
      dispatchGetCompanies,
      dispatchEditSubContractorOnSubmit,
      dispatchCreateSubContractorOnSubmit,
    } = this.props;

    return (
      <CrudBasePage
        Icon={Icon}
        title={breadcrumb}
        displayAddButton
        displaySearchField
        dataState={dataState}
        items={subContractors}
        SortableListProps={{
          actions: this.actions,
          columns: this.columns,
          getKey: x => x.get("id"),
          createSortableListRowProps: item => ({
            component: Link,
            to: toSubContractorCard(item.get("id")),
          }),
        }}
        CreateModalProps={{
          submitText: "Create",
          title: "New Sub-Contractor",
          onEnter: dispatchGetCompanies,
          onSubmit: dispatchCreateSubContractorOnSubmit,
        }}
        CreateEntityFormComponent={SubContractorForm}
        createEntityForm={{
          form: SUB_CONTRACTOR_FORM.ID,
        }}
        EditModalProps={{
          submitText: "Save",
          title: "Edit Employee Group",
          onEnter: dispatchGetCompanies,
          formTitleField: SUB_CONTRACTOR_FORM.NAME,
          onSubmit: dispatchEditSubContractorOnSubmit,
        }}
        EditEntityFormComponent={SubContractorForm}
        editEntityForm={{
          form: SUB_CONTRACTOR_FORM.ID,
        }}
      />
    );
  }
}

export default compose(
  connect(
    state => ({
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_SUB_CONTRACTORS,
        ACTIONS.DELETE_SUB_CONTRACTOR,
      ),
      subContractors: getSubContractorsFromState(state),
    }),
    {
      dispatchOnLoad: getSubContractors,
      dispatchGetCompanies: getCompanies,
      dispatchEditSubContractorOnSubmit: editSubContractorOnSubmit,
      dispatchDeleteSubContractor: deleteSubContractor,
      dispatchCreateSubContractorOnSubmit: createSubContractorOnSubmit,
    },
  ),
)(SettingsSubContractorsContainer);
